"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCandyGuard = void 0;
const updateCandyGuard_1 = require("./generated/instructions/updateCandyGuard");
const hooked_1 = require("./hooked");
function updateCandyGuard(context, input) {
    const { guards, groups, ...rest } = input;
    const program = context.programs.get('mplCandyGuard');
    const serializer = (0, hooked_1.getCandyGuardDataSerializer)(context, program);
    const data = serializer.serialize({ guards, groups });
    return (0, updateCandyGuard_1.updateCandyGuard)(context, { ...rest, data });
}
exports.updateCandyGuard = updateCandyGuard;
//# sourceMappingURL=updateCandyGuard.js.map